import { CUSTOMER_SERVER_CONFIG, SERVER_CONFIG, USER_TYPES } from '@helpers/constants';
import httpClient, { httpClient2 } from './index.service';
import { filterNonEmptyValues, getPermissionFromLocalStorage } from '@helpers/utils';

export interface IFetchAllOrder {
  page?: number;
  search_text?: string;
  order_state?: string | null;
  users_list?: string;
  order_created_start_date?: string;
  order_created_end_date?: string;
  bl_or_awb_start_date?: string;
  bl_or_awb_end_date?: string;
  supply_type_list?: string;
  incoterms_list?: string;
  supplier_id_list?: string;
  customer_id_list?: string;
  product_id_list?: string;
}

export async function fetchEntityList() {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.listEntity}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchEntityBankList(id: string) {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.listEntityBankInfo}${id}/`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function createOrder(requestBody: any) {
  try {
    const response = await httpClient.post(`${SERVER_CONFIG.createOrder}`, requestBody);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchAllOrder(params: IFetchAllOrder) {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const paramList = filterNonEmptyValues(params);
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.listOrder}/`
      : SERVER_CONFIG.listOrder;
  try {
    const response = await httpClient.get(URL, {
      params: paramList
    });
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchOrderInfo(id: string) {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.order}/${id}/overview/`
      : `${SERVER_CONFIG.fetchOrderInfo}${id}/`;
  try {
    const response = await httpClient.get(URL);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function postPerformaInvoice(taskId: string, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `order/${taskId}/generate-proforma-invoice/`,
      requestBody
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function rectifyPerformaInvoice(taskId: string, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.rectifyPi}`,
      requestBody
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchOrderInfoFinance(id: string) {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.fetchOrderInfoFinance}${id}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateOrderInfo(id: string, requestBody: any) {
  try {
    const response = await httpClient.patch(`${SERVER_CONFIG.updateOrderInfo}${id}/`, requestBody);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addOrderPaymentDetail(id: string, requestBody: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.uploadPaymentProof}`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function addCRLDetails(task_id: any, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${task_id}/${SERVER_CONFIG.createCRLDetails}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function approveOrder(id: string) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.approveOrder}/`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addCI(taskId: string, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.createCI}`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function rejectOrder(id: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.rejectOrder}/`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function assignPersonnel(requestBody: any, taskId: string) {
  try {
    const response = await httpClient.patch(
      `order/${taskId}/${SERVER_CONFIG.assignPersonnel}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addRodtepDrawback(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/add-rodtep-drawback/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateGateInTask(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/update-gate-in/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateMaterialLifting(taskId: string, supplier_id: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.materialLiftingConfirmation}/${supplier_id}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchReviewById(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.getReviewById}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function approvePerformaReview(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.approvePi}`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateShipmentCLearanceTask(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/update-shipment-clearance/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function rejectPerformaReview(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.rejectPi}`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function rectifyOrder(id: string, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.rectifyOrder}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPostDocumentsById(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.postShipment}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPreDocumentsById(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.preShipment}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getExportShipmentDocsById(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.exportClearance}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function uploadShipmentDocuments(
  id: string,
  uploadType: 'order_related' | 'order_item_related',
  requestBody: any
) {
  const UPLOAD_TYPES = {
    order_related: SERVER_CONFIG.orderDocument,
    order_item_related: SERVER_CONFIG.orderItemDocument
  };
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${id}/${UPLOAD_TYPES?.[uploadType]}`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateShipmentDocuments(
  id: string,
  uploadType: 'order_related' | 'order_item_related',
  requestBody: any
) {
  const UPLOAD_TYPES = {
    order_related: SERVER_CONFIG.orderDocument,
    order_item_related: SERVER_CONFIG.orderItemDocument
  };
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${UPLOAD_TYPES?.[uploadType]}${id}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updatePreShipment(id: string) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.preShipment}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updatePostShipment(id: string) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.postShipment}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateExportClearance(id: string, body?: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.exportClearance}`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getCRLDetails(id: string) {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.crl}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function createPurchaseOrder(task_id: any, supplier_id: any, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.getPO}/${task_id}/generate-purchase-order/${supplier_id}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchPOReviewById(order_id: string, supplierId: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${order_id}/${supplierId}/${SERVER_CONFIG.getPOReview}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchPOReviewByIdWithFormattedAmount(
  order_id: string,
  supplierId: string,
  isFormmatted: number
) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${order_id}/${supplierId}/${SERVER_CONFIG.getPOReview}?is_formatted=${isFormmatted}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function approvePurchaseReview(taskId: string, supplierId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.approvePo}/${supplierId}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function rectifyPurchaseOrder(taskId: string, supplierId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.rectifyPo}/${supplierId}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function rejectPurchaseOrder(taskId: string, supplierId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.rejectPo}/${supplierId}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getDocuments(order_id: string, filters?: any) {
  const query: string[] = [];
  if (filters) {
    if (filters?.tags?.length) {
      filters.tags.forEach((tag: any) => {
        query.push(`internal_tags=${tag?.value}`);
      });
    }
    if (filters?.supplier?.length) {
      filters.supplier.forEach((supplier: any) => {
        query.push(`supplier_id=${supplier?.value}`);
      });
    }
    if (filters?.order_item?.length) {
      filters.order_item.forEach((order_item: any) => {
        query.push(`order_item_id=${order_item?.value}`);
      });
    }
    if (filters?.customer_shared_docs_only) {
      query.push(`customer_shared_docs_only=${filters?.customer_shared_docs_only}`);
    }
    if (filters?.customer_info) {
      query.push(`customer_info=${filters?.customer_info}`);
    }
  }
  const userType = getPermissionFromLocalStorage()?.user_type;
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.order}/${order_id}/${CUSTOMER_SERVER_CONFIG.documents}/`
      : `${SERVER_CONFIG.order}/${order_id}/${SERVER_CONFIG.orderDocumentList}?${
          query?.length ? query.join('&') : ''
        }`;
  try {
    const response = await httpClient.get(URL);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAllOrderDocZip(id: string, documentIds: Array<string>) {
  try {
    const response = await httpClient2.get(
      `order/${id}/${SERVER_CONFIG.getOrderDocZip}?document_ids=${documentIds.join(',')}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAllOrderPhotos(id: string, page: number) {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.order}/${id}/${CUSTOMER_SERVER_CONFIG.getOrderImages}/`
      : `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.getOrderImages}`;
  try {
    const response = await httpClient.get(URL, {
      params: {
        ...(page && { page: page })
      }
    });
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function uploadOrderPhotos(orderId: string, body: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.getOrderImages}`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAddDocFilterOptions(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.formFilterOptions.orderDocUpload}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function uploadOrderOtherDoc(orderId: string, body: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.addOrderOtherDoc}/upload/v1/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getOtherDocuments(order_id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${order_id}/${SERVER_CONFIG.getOrderOtherDoc}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPendingTasks(orderId: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.getPendingTasks}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getShipmentTrackingDetails(orderId: string) {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.order}/${orderId}/${CUSTOMER_SERVER_CONFIG.shipmentTracking}/`
      : `${SERVER_CONFIG.shipmentTracking}/${SERVER_CONFIG.order}/${orderId}/`;
  try {
    const response = await httpClient.get(URL);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function generateCommercialInvoice(taskId: string, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.generateCommercialInvoice}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPaymentTermsFilterOptions() {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.formFilterOptions.paymentTerms}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPackagingListFilterOptions() {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${SERVER_CONFIG.formFilterOptions.packaging}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getOrderItemDetails(orderId: string, params?: any) {
  const paramsList: any = [];
  if (params && Object.keys(params).length) {
    Object.keys(params).forEach((key) => {
      if (key && params[key]) {
        paramsList.push(`${key}=${params[key]}`);
      }
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.orderItems}/?${paramsList.join('&')}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateOrderOtherDoc(orderId: string, body: any, docId: string) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.addOrderOtherDoc}/${docId}/v1/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function deleteOrderOtherDoc(orderId: string, docId: string) {
  try {
    const response = await httpClient.delete(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.addOrderOtherDoc}/${docId}/v1/`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function createShippingInstructions(task_id: any, requestBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${task_id}/${SERVER_CONFIG.generateShippingInstruction}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addTaskEstimate(id: string, requestBody?: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.addTaskEstimates}`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function updateTaskEstimate(id: string, requestBody?: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.updateTaskEstimates}`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function orderPendingActions(id: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${id}/${SERVER_CONFIG.pendingActionsInOrder}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPaymentTermSuffixFilterOptions() {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.formFilterOptions.paymentTermsSuffix}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function resolveInconsistency(orderId: string, documentId: string, requestBody: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.addOrderOtherDoc}/${documentId}/${SERVER_CONFIG.resolveInconsistency}/`,
      requestBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPocs(orderId: string) {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const URL =
    userType === USER_TYPES.customer
      ? `${CUSTOMER_SERVER_CONFIG.main}/${CUSTOMER_SERVER_CONFIG.order}/${orderId}/${CUSTOMER_SERVER_CONFIG.getOrderPoc}/`
      : `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.getOrderPoc}`;
  try {
    const response = await httpClient.get(URL);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function deleteStuffingPhotos(orderId: string, stuffingIds: string[]) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.deleteStuffingPhotos}`,
      {
        stuffing_image_ids: stuffingIds
      }
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getReadableOrderIdList(readableOrderId = '') {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${SERVER_CONFIG.readableOrderIdList}?readable_order_id=${readableOrderId}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getAdjacentOrderIds(orderId: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.listOrder}${orderId}/${SERVER_CONFIG.adjacent}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getDocThatWillBeModified(orderId: string, body: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.getDocThatWillBeModified}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function orderEdit(orderId: string, body: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.editOrder}/`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function checkOrderEditFields(orderId: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.checkOrderEditFields}/`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getTaskTypeList() {
  try {
    const response = await httpClient.get(`${SERVER_CONFIG.order}/${SERVER_CONFIG.taskType}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function createNotes(orderId: string, params: any) {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.createNotes}`,
      params
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getNotes(orderId: string, params?: any) {
  const queryParams = [];
  if (params?.page) {
    queryParams.push(`page=${params?.page}`);
  }
  if (params?.is_private) {
    queryParams.push(`is_private=${params?.is_private}`);
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.getNotes}?${
        queryParams?.length ? queryParams.join('&') : ``
      }`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function deleteNote(isPrivate: boolean, orderId: string, noteId: string) {
  try {
    const response = await httpClient.put(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.createNotes}${noteId}/${SERVER_CONFIG.delete}/?is_private=${isPrivate}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function editNotes(isPrivate: boolean, orderId: string, noteId: string, params: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${orderId}/${SERVER_CONFIG.createNotes}${noteId}/?is_private=${isPrivate}`,
      params
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getPOInitialData(orderId: string, supplierId: string) {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.order}/${orderId}/${supplierId}/${SERVER_CONFIG.getPOInitialData}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addRodTepConfirmation(taskId: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.rodtepConfirmation}/`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addDrawbackConfirmation(taskId: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.drawbackConfirmation}/`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function uploadEBRCConfirmation(taskId: string, body: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${taskId}/${SERVER_CONFIG.uploadEBRCConfirmation}`,
      body
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

// Get Supplier List after Selecting Document Type in Order Document Upload
export async function getSupplierFilterOptions(params: any, order_ids: any) {
  let paramQuery = '';
  if (params && Object.keys(params)?.length) {
    paramQuery = Object.keys(params)
      .map((key) => {
        if (params[key]) {
          return `${key}=${params[key]}`;
        }
      })
      .join('&');
  }
  if (order_ids?.length) {
    order_ids?.forEach((order: any) => {
      if (order?.order_id && order?.order_id?.length) paramQuery += `&order_id=${order?.order_id}`;
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.formFilterOptions.supplierName}?${paramQuery}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getProformaInvoiceDetails(
  orderIds: any,
  invoice_type: number,
  supplierId: string
) {
  let paramQuery = '';
  if (orderIds?.length) {
    orderIds?.forEach((order: any) => {
      paramQuery += `&order_id=${order}`;
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.payments}${SERVER_CONFIG.invoices}${SERVER_CONFIG.pi}${SERVER_CONFIG.formFilterOptions.index}?invoice_type=${invoice_type}&supplier=${supplierId}${paramQuery}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getOrderItemFilterOptions(params: any, order_ids: any) {
  let paramQuery = '';
  if (params && Object.keys(params)?.length) {
    paramQuery = Object.keys(params)
      .map((key) => {
        if (params[key]) {
          return `${key}=${params[key]}`;
        }
      })
      .join('&');
  }
  if (order_ids?.length) {
    order_ids?.forEach((order: any) => {
      if (order?.order_id && order?.order_id?.length) paramQuery += `&order_id=${order?.order_id}`;
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.formFilterOptions.orderItem}?${paramQuery}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function deletePoc(orderPOCId: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${SERVER_CONFIG.getOrderPoc}/${orderPOCId}/${SERVER_CONFIG.deletePOC}`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function addEditPOC(orderPOCId: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${SERVER_CONFIG.getOrderPoc}/${orderPOCId}/${SERVER_CONFIG.addPOC}`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function generateBillOfLading(task_id: string, reqBody: any) {
  try {
    const response = await httpClient.patch(
      `${SERVER_CONFIG.order}/${task_id}/${SERVER_CONFIG.generateBOL}`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
}
